import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "toolbox"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "账号/联系人", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存");

import { computed, reactive, ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getVexTableProps } from '@/config';
import { getSalesmanListBySupplierId } from '@/request';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'supplier-user-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    const route = useRoute();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      var _table$value;

      keyword.value = '';
      selectedList.value = [...props.selectedList];
      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    });
    const table = ref();
    const keyword = ref('');
    const tableOptions = getVexTableProps({
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return !props.selectedList.find(item => row.supUserId == item.supUserId);
        }

      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '登录账号',
        field: 'loginName'
      }, {
        title: '姓名',
        field: 'linkMan'
      }, {
        title: '联系电话',
        field: 'linkPhone'
      }, {
        title: '业务员类型',
        field: 'salesmanType'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            return new Promise(resolve => {
              let params = {
                page: page.currentPage,
                rows: page.pageSize,
                supplierId: route.query.supplierId,
                structureId: route.query.supplierId,
                userType: 2,
                levelType: 0,
                keyword: keyword.value
              };
              getSalesmanListBySupplierId(params).then(res => {
                resolve({
                  total: res.total,
                  result: res.rows
                });

                if (selectedList.value.length) {
                  setTimeout(() => {
                    let selectedRows = data.rows.filter(item => selectedList.value.find(v => v.supUserId == item.supUserId));
                    table.value.setCheckboxRow(selectedRows, true);
                  }, 300);
                }
              });
            });
          }
        }
      }
    });
    const form = reactive({
      linkMan: ''
    });

    function resetHandle() {
      var _table$value2;

      form.linkMan = '';
      (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.commitProxy('reload');
    }

    const selectedList = ref([]);

    function tableSelectHandle(e) {
      let {
        row,
        checked
      } = e;
      let findIndex = selectedList.value.findIndex(v => v.supUserId == row.supUserId);

      if (checked && findIndex == -1) {
        selectedList.value.push(row);
      } else {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle(e) {
      let {
        records,
        checked
      } = e;

      if (checked) {
        records.forEach(item => {
          if (selectedList.value.find(v => v.supUserId == item.supUserId)) return;
          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          let findIndex = selectedList.value.findIndex(v => v.supUserId === item.supUserId);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function submit() {
      emits('success', selectedList.value.map(v => ({
        supUserId: v.supUserId,
        linkMan: v.linkMan
      })));
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择人员",
        width: "800px",
        "custom-class": "rule-supplier-user-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入",
          style: {
            "width": "240px",
            "margin-right": "10px"
          }
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: resetHandle
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })])]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0
        }, _unref(tableOptions), {
          ref_key: "table",
          ref: table,
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};